import * as React from "react";
const SvgFiRrDumpster = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-dumpster_svg__a)">
      <path
        fill="#062147"
        d="M24 5c0-2.757-2.243-5-5-5H5C2.243 0 0 2.243 0 5l.003 2.083.694 8.332a5.02 5.02 0 0 0 2.302 3.795v1.29c0 1.93 1.57 3.5 3.5 3.5s3.5-1.57 3.5-3.5V20h4v.5c0 1.93 1.57 3.5 3.5 3.5s3.5-1.57 3.5-3.5v-1.29a5.01 5.01 0 0 0 2.302-3.795l.698-8.251C24.008 7.111 24 5 24 5m-2 0 .002 1H18V2h1c1.654 0 3 1.346 3 3m-9 1V2h3v4zM8 6V2h3v4zM5 2h1v4H2V5c0-1.654 1.346-3 3-3m3 18.5c0 .827-.673 1.5-1.5 1.5S5 21.327 5 20.5v-.547q.335.047.681.047H8zm11 0c0 .827-.673 1.5-1.5 1.5s-1.5-.673-1.5-1.5V20h2.319q.346 0 .681-.047zm2.31-5.251A3.02 3.02 0 0 1 18.32 18H5.681a3.02 3.02 0 0 1-2.99-2.751L2.087 8h19.827z"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-dumpster_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrDumpster;
